import React, { forwardRef } from "react";
import "./receipt.scss";
import { formatMoney } from "utils/money";

const Receipt = forwardRef(({ order, className = "hidden" }, ref) => {
    return (
        <div ref={ref} className={`receipt ${className}`.trim()}>
            <h6>طلب رقم {order?.id}</h6>
            <hr color="black" />

            <div className="info">
                <p>اسم الزبون : {order?.name}</p>
                <p>هاتف الزبون : {order?.phone}</p>
                <p>العنوان : {order?.address}</p>
            </div>

            {/* THE NOTE THE CUSTOMER WROTE FOR THE WHOLE ORDER.
             *
             * The receipt printed `product.notes` per line and never this one,
             * so the restaurant never saw it: 2,848 of the 10,546 orders since
             * 1 August carry one — 27% — and they are kitchen instructions,
             * not metadata. «حط قطر علا جنب ولقطايف يكونو طازه يقرمشو»,
             * «كلو حرييييف», «بدون تأخير». One of them was about the money.
             *
             * Above the items, because it applies to all of them and the
             * kitchen reads it before making anything. Bold, because a note
             * that prints as quietly as the address is a note that gets
             * skipped. Hidden entirely when there is none, so the 73% of
             * receipts without one do not grow an empty line. */}
            {order?.notes ? (
                <div className="order-note">
                    <p className="order-note__label">ملاحظات الطلب:</p>
                    <p>{order.notes}</p>
                </div>
            ) : null}

            {order?.cart_products?.map((product, i) => (
                <div key={i} className="item">
                    <p>
                        • {product.product.title} - {formatMoney(product.subtotal)}
                    </p>
                    <p>العدد : {product.quantity}</p>
                    <p>ملاحظات : {product.notes || "لا يوجد"}</p>

                    {product.options?.length > 0 && (
                        <>
                            <p>الإضافات:</p>
                            {product.options.map((addition, idx) => (
                                <span key={idx}>{addition.name} - </span>
                            ))}
                        </>
                    )}
                </div>
            ))}

            <p>قيمة الطلب : {formatMoney(order?.subtotal)}</p>
            <p>الشحن : {formatMoney(order?.shipping)}</p>

            <p className="total">المجموع : {formatMoney(order?.total)}</p>
        </div>
    );
});

Receipt.displayName = "Receipt";

export default Receipt;
